'use client';

import { Box, Typography, Button, styled } from '@mui/material';
import React, { useState } from 'react';
import Iconify from 'src/components/iconify';
import { useTranslate } from 'src/locales'; // assuming this is your hook

const GlassBox = styled(Box)(({ theme }) => ({
  background: 'rgba(0, 0, 0, 0.6)',
  backdropFilter: 'blur(10px)',
  borderRadius: theme.shape.borderRadius,
  border: '1px solid rgba(255, 217, 102, 0.2)',
  padding: theme.spacing(2),
  color: '#fff',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '1px',
    background:
      'linear-gradient(90deg, rgba(255,217,102,0) 0%, rgba(255,217,102,0.3) 50%, rgba(255,217,102,0) 100%)',
  },
}));

const AmberText = styled(Typography)(({ theme }) => ({
  color: '#FFD966',
}));

const PaymentHoldAlert = () => {
  const [expanded, setExpanded] = useState(false);
  const { t: tEvent } = useTranslate('event');

  return (
    <GlassBox>
      <Box display="flex" alignItems="flex-start" gap={2}>
        <Iconify icon="material-symbols:info-outline" sx={{ color: '#FFD966', mt: 0.5 }} />
        <Box sx={{ width: '100%' }}>
          <AmberText variant="subtitle1" fontWeight="medium" gutterBottom>
            {tEvent('payment-hold.title')}
          </AmberText>

          <Typography variant="body2" sx={{ color: '#E0E0E0', mb: 1 }}>
            {tEvent('payment-hold.description')}
          </Typography>

          {!expanded ? (
            <Button
              variant="text"
              sx={{
                color: '#FFD966',
                p: 0,
                textTransform: 'none',
                fontWeight: 'normal',
                '&:hover': { backgroundColor: 'transparent' },
              }}
              endIcon={<Iconify icon="material-symbols:expand-more" />}
              onClick={() => setExpanded(true)}
            >
              {tEvent('payment-hold.see-details')}
            </Button>
          ) : (
            <>
              <Box sx={{ my: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box display="flex" alignItems="flex-start" gap={1}>
                  <Iconify
                    icon="material-symbols:check-circle"
                    sx={{ color: '#4CAF50', fontSize: '1.2rem', mt: 0.3 }}
                  />
                  <Typography variant="body2" sx={{ color: '#E0E0E0' }}>
                    <strong style={{ color: '#81C784' }}>
                      {tEvent('payment-hold.accepted.label')}:
                    </strong>{' '}
                    {tEvent('payment-hold.accepted.text')}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="flex-start" gap={1}>
                  <Iconify
                    icon="material-symbols:cancel"
                    sx={{ color: '#F44336', fontSize: '1.2rem', mt: 0.3 }}
                  />
                  <Typography variant="body2" sx={{ color: '#E0E0E0' }}>
                    <strong style={{ color: '#E57373' }}>
                      {tEvent('payment-hold.rejected.label')}:
                    </strong>{' '}
                    {tEvent('payment-hold.rejected.text')}
                  </Typography>
                </Box>
              </Box>

              <Button
                variant="text"
                sx={{
                  color: '#FFD966',
                  p: 0,
                  textTransform: 'none',
                  fontWeight: 'normal',
                  '&:hover': { backgroundColor: 'transparent' },
                }}
                endIcon={<Iconify icon="material-symbols:expand-less" />}
                onClick={() => setExpanded(false)}
              >
                {tEvent('payment-hold.hide-details')}
              </Button>
            </>
          )}
        </Box>
      </Box>
    </GlassBox>
  );
};

export default PaymentHoldAlert;
